import Vue from 'vue';
import VueRouter from 'vue-router';

import auth from "@/auth/authService";
import Profile from "@/views/Profile";
import Home from '@/components/Home';
import Images from '@/components/Images';
import ImageDetails from '@/components/ImageDetails';
import ImageCreds from '@/components/ImageCreds';
import Devices from '@/components/Devices';
import DeviceDetails from '@/components/DeviceDetails';
import Templates from '@/components/Templates';
import TemplateDetails from '@/components/TemplateDetails';
import Upstream from '@/components/Upstream';
import CoolError from '@/components/Error'
import Callback from '@/components/Callback';

//Handle NavigationDuplicated exception when clicking on the same link twice
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(error => {
      if (error.name != "NavigationDuplicated") {
        throw error;
      }
  }
  )
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Home},
    { name: 'callback', path: '/callback', component: Callback },
    { name: 'home', path: '/', component: Home},
    { name: 'images', path: '/images', component: Images},
    { name: 'image-details', path: '/images/:ImageID', component: ImageDetails},
    { name: 'image-creds', path: '/credentials', component: ImageCreds},
    { name: 'devices', path: '/devices', component: Devices},
    { name: 'device-details', path: '/devices/:DeviceID', component: DeviceDetails },
    { name: 'templates', path: '/templates', component: Templates},
    { name: 'template-details', path: '/templates/:TemplateID', component: TemplateDetails },
    { name: 'upstream', path: '/upstream', component: Upstream},
    { name: 'profile', path: '/profile', component: Profile },
    { name: 'error', path: '/cool/error', component: CoolError },
    { name: 'docs-page', path: '/docs', beforeEnter() {
      return window.location = window.location.protocol+'//'+window.location.hostname+':'+window.location.port+"/docs/index.html";
    }

  }
  ] 
});

// NEW - add a `beforeEach` handler to each route
router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV == 'development') { 
    return next();
  }

  if (to.path === "/" || to.path === "/callback" || auth.isAuthenticated()) {
    return next();
  }

  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  auth.renewTokens().then(() => { return next(); })
  .catch(() => { auth.login({ target: to.path })});
});

export default router;
